import { CiStatus } from 'basics/enums/maya.enums';
import useGetAllCustomerInitiativeTypeQuery from 'basics/graphql/queries/getAllCustomerInitiatives';
import { CiFilter, CustomerInitiative } from 'generated/maya.types';

const useCustomerInitiativeTypeOptions = (filters: CiFilter = {}) => {
  const { data: customerInitiativeType } = useGetAllCustomerInitiativeTypeQuery(
    undefined,
    {
      status: [CiStatus.DRAFT, CiStatus.ACTIVE],
      ...filters,
    },
  );
  const customerInitiativeOptions = customerInitiativeType.map((element: CustomerInitiative) => {
    return {
      id: element._id,
      label: element.title,
    };
  });

  return customerInitiativeOptions;
};

export default useCustomerInitiativeTypeOptions;

